module.exports = __webpack_public_path__ + "static/media/remodeling.72740aff.svg";